import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Continuous Integration",
  "description": "Recipes for using Turborepo with Vercel, GitHub Actions, and other continuous integration providers."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo not only speeds up builds, but also the rest of your Continuous Integration pipeline by using Remote Caching. Below are a few platform recipes to use Turborepo with your CI providers."
  }, {
    "heading": "general-setup",
    "content": "To enable Remote Caching for your CI:"
  }, {
    "heading": "general-setup",
    "content": "Setup the environment variables for Turborepo in your CI to access your Remote Cache."
  }, {
    "heading": "general-setup",
    "content": "Variable"
  }, {
    "heading": "general-setup",
    "content": "Description"
  }, {
    "heading": "general-setup",
    "content": "TURBO_TOKEN"
  }, {
    "heading": "general-setup",
    "content": "The Bearer token to access the Remote Cache"
  }, {
    "heading": "general-setup",
    "content": "TURBO_TEAM"
  }, {
    "heading": "general-setup",
    "content": "The account name associated with your repository. When using' ' Vercel Remote Cache, this is your team's slug."
  }, {
    "heading": "general-setup",
    "content": "Clone your repository."
  }, {
    "heading": "general-setup",
    "content": "Install your dependencies through your package manager."
  }, {
    "heading": "general-setup",
    "content": "Run your tasks through turbo."
  }],
  "headings": [{
    "id": "general-setup",
    "content": "General Setup"
  }]
};
import {Cards, Card} from '#components/card';
export const toc = [{
  depth: 2,
  url: "#general-setup",
  title: _jsx(_Fragment, {
    children: "General Setup"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    ol: "ol",
    p: "p",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo not only speeds up builds, but also the rest of your Continuous Integration pipeline by using ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Caching"
      }), ". Below are a few platform recipes to use Turborepo with your CI providers."]
    }), "\n", _jsxs(Cards, {
      children: [_jsx(Card, {
        title: "Vercel (Zero configuration)",
        href: "/docs/guides/ci-vendors/vercel"
      }), _jsx(Card, {
        title: "GitHub Actions",
        href: "/docs/guides/ci-vendors/github-actions"
      }), _jsx(Card, {
        title: "CircleCI",
        href: "/docs/guides/ci-vendors/circleci"
      }), _jsx(Card, {
        title: "GitLab CI",
        href: "/docs/guides/ci-vendors/gitlab-ci"
      }), _jsx(Card, {
        title: "Travis CI",
        href: "/docs/guides/ci-vendors/travis-ci"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "general-setup",
      children: "General Setup"
    }), "\n", _jsx(_components.p, {
      children: "To enable Remote Caching for your CI:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Setup the environment variables for Turborepo in your CI to access your Remote Cache.", "\n", _jsxs(_components.table, {
          children: [_jsx(_components.thead, {
            children: _jsxs(_components.tr, {
              children: [_jsx(_components.th, {
                children: "Variable"
              }), _jsx(_components.th, {
                children: "Description"
              })]
            })
          }), _jsxs(_components.tbody, {
            children: [_jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                children: _jsx(_components.code, {
                  children: "TURBO_TOKEN"
                })
              }), _jsx(_components.td, {
                children: "The Bearer token to access the Remote Cache"
              })]
            }), _jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                children: _jsx(_components.code, {
                  children: "TURBO_TEAM"
                })
              }), _jsxs(_components.td, {
                children: ["The account name associated with your repository. When using", ' ', " ", _jsx("a", {
                  href: "https://vercel.com/docs/monorepos/remote-caching#vercel-remote-cache",
                  rel: "noreferrer noopener",
                  target: "_blank",
                  children: "Vercel Remote Cache"
                }), ", this is ", _jsx(_components.a, {
                  href: "https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fsettings&title=Get+team+slug",
                  children: "your team's slug"
                }), "."]
              })]
            })]
          })]
        }), "\n"]
      }), "\n", _jsx(_components.li, {
        children: "Clone your repository."
      }), "\n", _jsx(_components.li, {
        children: "Install your dependencies through your package manager."
      }), "\n", _jsxs(_components.li, {
        children: ["Run your tasks through ", _jsx(_components.code, {
          children: "turbo"
        }), "."]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
